import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { deleteEmployee } from "@tCentro/Services/CENAdminEmployeeService";

export interface DeleteEmployeeParameter extends HasOnSuccess<void>, HasOnError<string> {
    employeeId: string;
}

type HandlerType = ApiHandler<DeleteEmployeeParameter, {}>;

export const DeleteEmployee: HandlerType = async props => {
    try {
        await deleteEmployee(props.parameter.employeeId);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess();
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to delete employee");
        }
    }
};

export const chain = [DeleteEmployee];
const deleteEmployeeData = createHandlerChainRunner(chain, "deleteEmployeeData");
export default deleteEmployeeData;
